export default function FullScreenLoader({children}) {
    return (
        <div className="overlay-full">
            {children}
        </div>
    )
}